import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const Unauthorized = () => {

    const userState = useSelector((state) => state.userReducer);
  const { errorMessage, user, isLogin } = userState;
  
  if(!isLogin) Navigate({to:"/login", replace:true})
  return (
    <div>Unauthorized</div>
  )
}

export default Unauthorized